import React, { useState, useEffect } from 'react';
import './App.css';
import { Map, Layers, Select, Overlay, Listeners, Analise } from './map'
import Navbar from './components/navbar/NavBar';
import LayersComponent from './components/layer/LayersComponent';
import LayerLegendsComponent from './components/layer/LayerLegendsComponent';
import LayerRegistry from './data/LayerRegistry';
import Explorar from './components/explorar'
import { isNullOrUndefined } from './Util';
import { navigate } from 'hookrouter';
import BoxPlotly from './components/charts/BoxPlotly';
import Histogramly from './components/charts/Histogramly';
import BarChartly from './components/charts/BarChartly';
import Sunburstly from './components/charts/Sunburstly';
import ScatterPlotly from './components/charts/ScatterPlotly';
import Documentos from './components/documentos';
import FloatingWindowDocumento from './components/boxdialog/FloatingWindowDocumento';
import FloatingWindow from './components/boxdialog/FloatingWindow';
import { Fab, Tooltip, Zoom } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { SpeedDial, SpeedDialAction } from '@material-ui/lab'
import CamadasIcon from "./assets/fabIcons/Camadas.svg";
import DocumentosIcon from "./assets/fabIcons/Documentos.svg";
import LegendasIcon from "./assets/fabIcons/Legendas.svg";
import LimiaresIcon from "./assets/fabIcons/Limiares.svg";
import BoxplotIcon from "./assets/fabIcons/Boxplot.svg";
import HistogramaIcon from "./assets/fabIcons/Histograma.svg";
import BarchartIcon from "./assets/fabIcons/Barchart.svg";
import SunburstIcon from "./assets/fabIcons/Sunburst.svg";
import DistribuicaoCumulativaIcon from "./assets/fabIcons/DistribuicaoCumulativa.svg";
import { GrupoAnaliseSolo, GruposAnaliseContrasteSolo } from './config/api';
//import { disableCache } from '@iconify/react';


function App() {

	const [showCamadas, setShowCamadas] = useState(false)
	const [showLegendas, setShowLegendas] = useState(true)
	const [showExplorar, setShowExplorar] = useState(true)
	const [showBoxplot, setShowBoxplot] = useState(false)
	const [showHistogram, setShowHistogram] = useState(false)
	const [showScatterplot, setShowScatterplot] = useState(false)
	const [showBarchart, setShowBarchart] = useState(false)
	const [showSunburst, setshowSunburst] = useState(false)
	const [openLimiares, setOpenLimiares] = React.useState(false);
	const [showDocumentosGerais, setShowDocumentosGerais] = useState(false)
	const [parametroSerie, setParametroSerie] = useState()
	const [menus, setMenus] = useState([])
	const [layers, setLayers] = useState([])
	const [layersToShow, setLayersToShow] = useState([])
	const [selectedFeatures, setSelectedFeatures] = useState([])
	const [featureSummaryOverlayCoordinate, setFeatureSummaryOverlayCoordinate] = useState([])
	const [featuresSummariesElements, setFeaturesSummariesElements] = useState([])
	const [analise, setAnalise] = useState()
	const [legendaAnalise, setLegendaAnalise] = useState()
	const [sizeLegenda, setSizeLegenda] = useState({ width: 220, height: 200 })
	const [sizeCamadas] = useState({ width: 320, height: 310 });
	const [sizeExplorar, setSizeExplorar] = useState({ width: 320, height: 548 })
	const [sizeDocumentos] = useState({ width: 700, height: 548 })
	const [tipoLimiarSelecionado, setTipoLimiarSelecionado] = useState([])
	const [abrirOuFecharSumario, setAbrirOuFecharSumario] = useState(false)
	const [sizeBoxplot] = useState({ width: 600, height: 300 })
	const [sizeHistogram] = useState({ width: 600, height: 250 })
	const [sizeBarchart] = useState({ width: 600, height: 250 })
	const [sizeSunburst] = useState({ width: 600, height: 250 })
	const [sizeScatterplot] = useState({ width: 600, height: 250 })
	const [visualizarDocumentoId, setVisualizarDocumentoId] = useState()
	const [restoreStyleFeatures, setRestoreStyleFeatures] = useState()
	//disableCache('all');

	const useStyles = makeStyles(theme => ({
		speedDial: {
			backgroundColor: "#FFF",
			"&:hover": {
				backgroundColor: "#FFF"
			}
		},
	}));
	const classes = useStyles();

	// const verificaLogado = () => {
	// 	const logado = sessionStorage.getItem('logado')
	// 	//console.log(logado);
	// 	if (!logado) {
	// 		navigate("/login")
	// 		return false
	// 	} else {
	// 		return true
	// 	}
	// }

	// useEffect(() => {
	// 	verificaLogado()
	// })

	useEffect(() => {
		const layers = [
			//{ visible: false, layer: LayerRegistry.grids },
			{ visible: false, layer: LayerRegistry.amostras },
			{ visible: false, layer: LayerRegistry.estradas },
			{ visible: false, layer: LayerRegistry.geologia },
			{ visible: false, layer: LayerRegistry.microbacias },
			{ visible: false, layer: LayerRegistry.minas },
			{ visible: false, layer: LayerRegistry.redesDeDrenagem },
			{ visible: false, layer: LayerRegistry.terrasIndigenas },
			{ visible: false, layer: LayerRegistry.unidadesConservacao },
			{ visible: true, layer: LayerRegistry.microbaciasAnalise, ocultarCamada: true },
			{ visible: true, layer: LayerRegistry.redesDeDrenagemAnalise, ocultarCamada: true },
		]
		setLayers(layers)

		const layersToShow = layers.filter(layer => layer.ocultarCamada)
		setLayersToShow(layersToShow)

	}, [])

	useEffect(() => {
		setMenus([
			{ label: 'Camadas', click: () => setShowCamadas(!showCamadas), isSelect: showCamadas },
			{ label: 'Legendas', click: () => setShowLegendas(!showLegendas), isSelect: showLegendas },
			{ label: 'Explorar', click: () => setShowExplorar(!showExplorar), isSelect: showExplorar },
			{ label: 'Boxplot', click: () => setShowBoxplot(!showBoxplot), isSelect: showBoxplot },
			{ label: 'Histograma', click: () => setShowHistogram(!showHistogram), isSelect: showHistogram },
			{ label: 'Gráfico de Barras', click: () => setShowBarchart(!showBarchart), isSelect: showBarchart },
			{ label: 'Sunburst', click: () => setshowSunburst(!showSunburst), isSelect: showSunburst },
			{ label: 'Distribuição Cumulativa', click: () => setShowScatterplot(!showScatterplot), isSelect: showScatterplot },
			{ label: 'Documentos', click: () => setShowDocumentosGerais(!showDocumentosGerais), isSelect: showDocumentosGerais }
		])
	}, [showCamadas, showLegendas, showExplorar, showBoxplot, showHistogram, showScatterplot, showBarchart, showSunburst, showDocumentosGerais])

	const renderFloatCamadas = () => {
		return (
			<FloatingWindow
				title="Camadas"
				left={50}
				top={70 + sizeExplorar.height + 16}
				size={sizeCamadas}
				className="floating-layers-component"
				close={() => setShowCamadas(!showCamadas)}
				isShow={showCamadas}
				showCloseButton={true}
			>
				<LayersComponent
					layers={layers}
					layersToShow={(layers) => configureLayersToShowComLimiarLayer(layers)} />
			</FloatingWindow>
		)
	}

	const configureLayersToShowComLimiarLayer = (layers) => {
		const limiarLayer = layersToShow.filter(layer => layer.layer.name === 'amostrasForaLimiar')[0]
		if (limiarLayer)
			layers.push(limiarLayer)

		setLayersToShow(layers)
	}

	const renderFloatLegendas = () => {
		return (
			<FloatingWindow
				title="Legendas"
				top={70}
				left={window.innerWidth - 16 - sizeLegenda.width}
				size={sizeLegenda}
				className="floating-layers-component"
				close={() => setShowLegendas(!showLegendas)}
				isShow={showLegendas}
				showCloseButton={true}
			>
				{showLegendas && (
					<LayerLegendsComponent
						layersToShow={layersToShow}
						selectedFeaturesChanged={(features) => setSelectedFeatures(features)}
						parametroSerie={parametroSerie}
						legendaAnalise={legendaAnalise}
						size={setSizeLegenda}
						restoreStyleFeatures={restoreStyleFeatures} />
				)}
			</FloatingWindow>
		)
	}

	const renderFloatExplorar = () => {
		return (
			<FloatingWindow
				title=""
				left={50}
				top={70}
				opacity={1}
				size={sizeExplorar}
				className="floating-layers-component"
				close={() => setShowExplorar(!showExplorar)}
				isShow={showExplorar}
				showCloseButton={false}
			>
				{showExplorar && (
					<Explorar
						carregarSolo={(dados) => carregarSolo(dados.parametro, dados.serie, dados.contrastar)}
						dadosAnalise={(analise) => setAnalise(analise)}
						cleanLegendaAnalise={() => setLegendaAnalise()}
						setParametroSerie={(parametro) => setParametroSerie(parametro)}
						clear={() => clear}
						size={(newSize) => setSizeExplorar(newSize)}
						setLimiar={(limiares) => showLimiares(limiares)}
						setTipoLimiarSelecionado={(limiares) => setTipoLimiarSelecionado(limiares)}
						visualizarDocumentoId={(parametroId) => {
							setShowDocumentosGerais(true)
							setVisualizarDocumentoId(parametroId)
						}} />
				)}
			</FloatingWindow>
		)
	}

	const renderFloatDocumentosGerais = () => {
		return (
			<FloatingWindowDocumento
				title="Documentos"
				left={window.innerWidth - 700 - 16}
				top={70}
				opacity={1}
				padding={30}
				size={sizeDocumentos}
				className="floating-layers-component"
				close={() => setShowDocumentosGerais(!showDocumentosGerais)}
				isShow={showDocumentosGerais}
				abrirOuFecharSumario={() => setAbrirOuFecharSumario(!abrirOuFecharSumario)}>
				{showDocumentosGerais && (
					<Documentos
						abrirOuFecharSumario={abrirOuFecharSumario}
						visualizarDocumentoId={visualizarDocumentoId}
					/>
				)}
			</FloatingWindowDocumento>
		)
	}

	const clear = () => {
		setAnalise()
		setLegendaAnalise()
	}

	const showLimiares = (limiares) => {
		if (!limiares || limiares.length === 0) {
			setLayersToShow(layersToShow.filter(layer => layer.layer.name !== "amostrasForaLimiar"))
			return
		}
		const newLimiarLayer = LayerRegistry.createLimiarLayer(limiares)
		const newLayersToShow = layersToShow.filter(layer => layer.layer.name !== "amostrasForaLimiar")
		newLayersToShow.push({ visible: true, layer: newLimiarLayer })
		setLayersToShow(newLayersToShow)
	}

	const carregarSolo = async (parametro, serie, contrastar) => {
		const newLayersToShow = layersToShow.filter(layer => layer.layer.name !== "amostrasForaLimiar" && layer.layer.name !== "Solo")
		const soloLayer = await LayerRegistry.createSoloLayer({ nome: 'Solo', parametro: parametro.nome, idParametroAnalise: parametro.id, idSerieAnalise: serie, contrastar: contrastar })
		newLayersToShow.push({ visible: true, layer: soloLayer })
		setLayersToShow(newLayersToShow)

		let grupoSolo
		if (contrastar)
			grupoSolo = await GruposAnaliseContrasteSolo(parametro.id, serie);
		else
			grupoSolo = await GrupoAnaliseSolo(parametro.id, serie);

		soloLayer.olLayer.getSource().on('change', event => {
			setAnalise({ grupos: grupoSolo });
		});
	}

	const renderFloatChartBoxplot = () => {
		return (
			<FloatingWindow
				opacity={1}
				title="Boxplot"
				left={50 + 320 + 16}
				top={70}
				size={sizeBoxplot}
				className="floating-layers-component"
				showCloseButton={true}
				close={() => setShowBoxplot(!showBoxplot)}
				isShow={showBoxplot}>
				{showBoxplot && (
					<BoxPlotly
						parametroSerie={parametroSerie}
						tipoLimiarSelecionado={tipoLimiarSelecionado}
					/>
				)}
			</FloatingWindow>
		)
	}

	const renderFloatChartHistogram = () => {
		return (
			<FloatingWindow
				opacity={1}
				title="Histograma"
				left={50 + 320 + 16}
				top={70}
				size={sizeHistogram}
				className="floating-layers-component"
				close={() => setShowHistogram(!showHistogram)}
				showCloseButton={true}
				isShow={showHistogram}>
				{showHistogram && (
					<Histogramly
						parametroSerie={parametroSerie}
						tipoLimiarSelecionado={tipoLimiarSelecionado}
					/>
				)}
			</FloatingWindow>
		)
	}

	const renderFloatChartScatterplot = () => {
		return (
			<FloatingWindow
				opacity={1}
				title="Distribuição Cumulativa"
				left={50 + 320 + 16}
				top={70}
				size={sizeScatterplot}
				className="floating-layers-component"
				close={() => setShowScatterplot(!showScatterplot)}
				showCloseButton={true}
				isShow={showScatterplot}>
				{showScatterplot && (
					<ScatterPlotly
						parametroSerie={parametroSerie}
						tipoLimiarSelecionado={tipoLimiarSelecionado}
					/>
				)}
			</FloatingWindow>
		)
	}

	const renderFloatChartBarchart = () => {
		return (
			<FloatingWindow
				opacity={1}
				title="Gráfico de Barras"
				left={50 + 320 + 16}
				top={70}
				size={sizeBarchart}
				className="floating-layers-component"
				close={() => setShowBarchart(!showBarchart)}
				showCloseButton={true}
				isShow={showBarchart}>
				{showBarchart && (
					<BarChartly
						parametroSerie={parametroSerie}
					/>
				)}
			</FloatingWindow>
		)
	}

	const renderFloatChartSunburst = () => {
		return (
			<FloatingWindow
				opacity={1}
				title="Sunburst"
				left={50 + 320 + 16}
				top={70}
				size={sizeSunburst}
				className="floating-layers-component"
				close={() => setshowSunburst(!showSunburst)}
				showCloseButton={true}
				isShow={showSunburst}>
				{showSunburst && (
					<Sunburstly
						parametroSerie={parametroSerie}
					/>
				)}
			</FloatingWindow>
		)
	}

	const updateListeners = (event) => {
		let arrFeatures = []
		let arrSummares = []

		const { map, pixel, coordinate } = event

		map.forEachFeatureAtPixel(pixel, (feature, olLayer) => {
			setFeaturesSummariesElements([])
			if (isNullOrUndefined(olLayer) || isNullOrUndefined(feature)) {
				return;
			}

			let layer = LayerRegistry.findLayerByOLLayer(olLayer);
			if (!layer) {
				layer = LayerRegistry.solo;
			}

			if (!layer || layer.disableSelect) return
			if (verifyFeatureAlredySelected(feature)) return

			if (!isNullOrUndefined(layer.createFeatureSummary)) {
				arrSummares.push(layer.createFeatureSummary(feature))
			}
			arrFeatures.push(feature)
		})

		if (arrFeatures.length === 0) {
			clearSelectedFeaturesAndFeaturesSummariesElements()
			return
		}

		setSelectedFeatures(arrFeatures)
		setFeaturesSummariesElements(arrSummares.map(s => s.element))
		setFeatureSummaryOverlayCoordinate(coordinate)
	}

	const verifyFeatureAlredySelected = (layer) => {
		const singleFeaturesSelectionLayersIds = [];

		if (!layer.multipleFeaturesSelection) {
			const featureAlreadyExistsForLayer = singleFeaturesSelectionLayersIds.indexOf(layer.id) !== -1;
			if (featureAlreadyExistsForLayer) {
				return true
			}
			singleFeaturesSelectionLayersIds.push(layer.id);
		}
		return false
	}

	const clearSelectedFeaturesAndFeaturesSummariesElements = () => {
		setSelectedFeatures([])
		setFeaturesSummariesElements([])
		setFeatureSummaryOverlayCoordinate(undefined)
	}

	const clearJanelas = () => {
		setShowCamadas(false)
		setShowLegendas(false)
		setShowExplorar(false)
		setShowBarchart(false)
		setShowBoxplot(false)
		setShowHistogram(false)
		setshowSunburst(false)
		setShowScatterplot(false)
		setShowDocumentosGerais(false)
	}

	return (
		<>
			{
				<>
					<Navbar menus={menus} clearJanelas={() => clearJanelas()} />
					{renderFloatCamadas()}
					{renderFloatLegendas()}
					{renderFloatExplorar()}
					{renderFloatDocumentosGerais()}
					{renderFloatChartBoxplot()}
					{renderFloatChartHistogram()}
					{renderFloatChartScatterplot()}
					{renderFloatChartBarchart()}
					{renderFloatChartSunburst()}

					<Map
						projection='EPSG:4326'
						center={[-49.9965, -6.198]}
						//zoom='9.5'
						zoom='8.5'
						onMouseLeave={clearSelectedFeaturesAndFeaturesSummariesElements}
					>
						<Listeners
							pointermove={updateListeners} />
						<Layers
							layers={layersToShow} parametroSerie={parametroSerie} />
						<Select
							features={selectedFeatures} />
						<Overlay
							position={featureSummaryOverlayCoordinate}
							offset={[10, 0]}
							positioning='bottom-left'
							className="popup">
							{featuresSummariesElements}
						</Overlay>
						<Analise
							analise={analise}
							legendaAnalise={setLegendaAnalise}
							parametroSerie={parametroSerie}
							restoreStyleFeatures={setRestoreStyleFeatures} />
					</Map>

					<div
						style={{
							position: "absolute",
							right: 32,
							bottom: 32 + 12,
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end"
						}}>
						<Tooltip
							title="Documentos"
							aria-label="Documentos"
							placement="left"
							style={{ marginRight: -10 }}
						>
							<Zoom in={true}>
								<Fab
									onClick={() => { setShowDocumentosGerais(!showDocumentosGerais) }}
									style={{
										backgroundColor: "#FFF",
										zIndex: 5
									}}
								>
									<img
										src={DocumentosIcon}
										width={"45%"}
										alt="Documentos"
									/>
								</Fab>
							</Zoom>
						</Tooltip>

						<div style={{ height: 16 }} />

						<SpeedDial
							ariaLabel="Limiares"
							icon={
								<img
									src={LimiaresIcon}
									width={"55%"}
									alt="Limiares"
								/>
							}
							onClick={() => { setOpenLimiares(true) }}
							onClose={() => { setOpenLimiares(false) }}
							// onOpen={() => { setOpenLimiares(true) }}
							open={openLimiares}
							direction={"left"}
							style={{ marginRight: -10, zIndex: 5 }}
							classes={{
								fab: classes.speedDial
							}}
						>
							<SpeedDialAction
								key={"Boxplot"}
								icon={
									<img
										src={BoxplotIcon}
										width={"55%"}
										alt="Boxplot"
									/>
								}
								tooltipPlacement="top"
								tooltipTitle={"Boxplot"}
								onClick={() => {
									setShowBoxplot(!showBoxplot)
									// setOpenLimiares(false)
								}}
							/>
							<SpeedDialAction
								key={"Histograma"}
								icon={
									<img
										src={HistogramaIcon}
										width={"55%"}
										alt="Histograma"
									/>
								}
								tooltipPlacement="top"
								tooltipTitle={"Histograma"}
								onClick={() => {
									setShowHistogram(!showHistogram)
									// setOpenLimiares(false)
								}}
							/>
							<SpeedDialAction
								key={"Barchart"}
								icon={
									<img
										src={BarchartIcon}
										width={"55%"}
										alt="Barchart"
									/>
								}
								tooltipPlacement="top"
								tooltipTitle={"Gráfico de Barras"}
								onClick={() => {
									setShowBarchart(!showBarchart)
									// setOpenLimiares(false)
								}}
							/>
							<SpeedDialAction
								key={"Sunburst"}
								icon={
									<img
										src={SunburstIcon}
										width={"55%"}
										alt="Sunburst"
									/>
								}
								tooltipPlacement="top"
								tooltipTitle={"Sunburst"}
								onClick={() => {
									setshowSunburst(!showSunburst)
									// setOpenLimiares(false)
								}}
							/>
							<SpeedDialAction
								key={"Distribuição Cumulativa"}
								icon={
									<img
										src={DistribuicaoCumulativaIcon}
										width={"55%"}
										alt="Distribuição Cumulativa"
									/>
								}
								tooltipPlacement="top"
								tooltipTitle={"Distribuição Cumulativa"}
								onClick={() => {
									setShowScatterplot(!showScatterplot)
									// setOpenLimiares(false)
								}}
							/>
						</SpeedDial>

						<div style={{ height: 16 }} />

						<Tooltip
							title="Camadas"
							aria-label="Camadas"
							placement="left"
							style={{ marginRight: -10 }}
						>
							<Zoom in={true}>
								<Fab
									onClick={() => { setShowCamadas(!showCamadas) }}
									style={{
										backgroundColor: "#FFF",
										zIndex: 5
									}}
								>
									<img
										src={CamadasIcon}
										width={"60%"}
										alt="Camadas"
									/>
								</Fab>
							</Zoom>
						</Tooltip>

						<div style={{ height: 16 }} />

						<Tooltip
							title="Legendas"
							aria-label="Legendas"
							placement="left"
							style={{ marginRight: -10 }}
						>
							<Zoom in={true}>
								<Fab
									onClick={() => { setShowLegendas(!showLegendas) }}
									style={{
										backgroundColor: "#FFF",
										zIndex: 5
									}}
								>
									<img
										src={LegendasIcon}
										width={"60%"}
										alt="Legendas"
									/>
								</Fab>
							</Zoom>
						</Tooltip>
					</div>
				</>
			}
		</>
	)
}

export default App;